/**
 * Склейка частей подписи банковского счёта в селектах.
 * null / undefined / пустая строка не попадают в подпись (не «undefined», не лишние пробелы).
 */
export function joinBankOptionLabelParts(
    ...parts: Array<string | number | null | undefined>
): string {
    return parts
        .filter((p) => p != null && String(p).trim() !== "")
        .map((p) => String(p).trim())
        .join(" ");
}
